import React, { useEffect, useState } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import KinosLeadModal from '../components/LeadGen/KinosLeadModal';

import NgHeroSection from '../components/ng/NgHeroSection';
import NgProblemSection from '../components/ng/NgProblemSection';
import NgHowItWorksSection from '../components/ng/NgHowItWorksSection';
import NgBenefitsSection from '../components/ng/NgBenefitsSection';
import NgTestimonialsSection from '../components/ng/NgTestimonialsSection';
import NgFeaturesTableSection from '../components/ng/NgFeaturesTableSection';
import NgPricingSection from '../components/ng/NgPricingSection';
import NgGuaranteeSection from '../components/ng/NgGuaranteeSection';
import NgFAQSection from '../components/ng/NgFAQSection';
import NgFinalCTASection from '../components/ng/NgFinalCTASection';

const NigeriaHome = () => {
  const [demoModalOpen, setDemoModalOpen] = useState(false);

  // Smooth scroll for anchor links (match LeadGenHome behavior)
  useEffect(() => {
    const anchors = document.querySelectorAll('a[href^="#"]');
    const handleClick = (e) => {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 100,
          behavior: 'smooth',
        });
      }
    };

    anchors.forEach((anchor) => {
      anchor.addEventListener('click', handleClick);
    });

    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleClick);
      });
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow pb-20 sm:pb-0">
        <NgHeroSection onOpenDemo={() => setDemoModalOpen(true)} />
        <NgProblemSection />
        <NgHowItWorksSection />
        <NgBenefitsSection />
        <NgTestimonialsSection />
        <NgFeaturesTableSection />
        <NgPricingSection />
        <NgGuaranteeSection />
        <NgFAQSection />
        {/* <NgFinalCTASection onOpenDemo={() => setDemoModalOpen(true)} /> */}
      </main>

      <KinosLeadModal
        open={demoModalOpen}
        onClose={() => setDemoModalOpen(false)}
        email=""
      />

      <Footer />

      {/* Mobile-only floating Free Trial CTA (fixed at bottom) */}
      <div className="fixed bottom-0 left-0 right-0 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-white/40 backdrop-blur-md border-t border-gray-200/40 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:hidden z-40">
        <a
          href="https://engagement.kolanut.ai/signup"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full py-3.5 rounded-full bg-green-600 text-white font-bold text-base shadow-lg hover:bg-green-700 active:scale-[0.98] transition-all duration-200"
        >
          Start Free 14-Day Trial
        </a>
      </div>
    </div>
  );
};

export default NigeriaHome;

